// Which corrido product the page talks to: the realistic one (/api/web/corrido,
// the default and the only one most accounts ever see) or the 3D animated twin
// (/api/web/corrido3d, services/corrido-3d on the server, its own GPU worker).
//
// The look is chosen by ?look=3d on the URL (kept for the tab in
// sessionStorage) or by the switch the corrido flow shows to accounts the 3D
// product is open to (GET /api/web/corrido3d/access). Every corrido fetch asks
// corridoApi() for its base at call time, so with no look set every URL is
// exactly what it was before this file existed.
//
// Media is NOT switched: both products hand the page signed media handles, and
// /api/web/corrido/image resolves any of them (lib/corrido-media.ts).

export type CorridoLook = "real" | "3d";

const KEY = "corrido.look";
const listeners = new Set<(look: CorridoLook) => void>();

function initial(): CorridoLook {
  try {
    const q = new URLSearchParams(window.location.search).get("look");
    if (q === "3d" || q === "real") {
      try { window.sessionStorage.setItem(KEY, q); } catch { /* private mode */ }
      return q;
    }
    return window.sessionStorage.getItem(KEY) === "3d" ? "3d" : "real";
  } catch {
    return "real";
  }
}

let current: CorridoLook = typeof window === "undefined" ? "real" : initial();

export function corridoLook(): CorridoLook {
  return current;
}

export function setCorridoLook(look: CorridoLook): void {
  if (look === current) return;
  current = look;
  try { window.sessionStorage.setItem(KEY, look); } catch { /* private mode */ }
  for (const fn of listeners) fn(look);
}

export function onCorridoLook(fn: (look: CorridoLook) => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** The corrido API base for the current look, plus `path` ("/runs", "/v2/health"...). */
export function corridoApi(path = ""): string {
  return (current === "3d" ? "/api/web/corrido3d" : "/api/web/corrido") + path;
}

/** Test seam only. */
export function _resetCorridoLook(look: CorridoLook = "real"): void {
  current = look;
  listeners.clear();
}
